module.exports = __webpack_public_path__ + "static/media/addOnIcon.13c083f6.svg";